const productInnerEls = document.querySelectorAll(".product-item__inner");
const currentSwatch = document.querySelector(".product__color-swatch.selected");

if (currentSwatch) {
  addProductBadges(currentSwatch, "product");
}

swatchHandler(productInnerEls);

function swatchHandler(productInnerEls) {
  productInnerEls.forEach((productInnerEl) => {
    const swatches = productInnerEl.querySelectorAll(
      ".product-swatches-options__item--swatch"
    );
    const template = "collection";

    if (swatches.length > 0) {
      addProductBadges(swatches[0], template);

      swatches.forEach((swatch) => {
        const hoverImage = swatch.dataset.variantImg;

        if (hoverImage) {
          const imageTwo = productInnerEl?.querySelector(
            ".product-item__image--two"
          );
          const hoverImageEl = productInnerEl?.querySelector(".hover-image");

          if (!hoverImageEl) return;

          swatch.addEventListener("mouseenter", () => {
            hoverImageEl.querySelector(".image__img").src = hoverImage;
            imageTwo.classList.remove("active");
            hoverImageEl.classList.remove("hover-image-hide");
            hoverImageEl.classList.add("active");

            addProductBadges(swatch, template);
          });

          swatch.addEventListener("mouseleave", () => {
            hoverImageEl.classList.add("hover-image-hide");
            hoverImageEl.classList.remove("active");

            addProductBadges(swatches[0], "collection");
          });
        }
      });
    }
  });
}

function addProductBadges(swatch, template) {
  let {
    badgeOne,
    badgeTwo,
    dateNow,
    startDateOne,
    endDateOne,
    startDateTwo,
    endDateTwo,
    bgOne,
    bgTwo,
    colorOne,
    colorTwo,
  } = swatch.dataset;

  const productInner =
    template == "collection"
      ? swatch.closest(".product-item__inner")
      : document.querySelector(".product");
  const productBadges = productInner.querySelector(".product-badges");
  const badgeOneEl = productBadges.querySelector(".variant-badge-one");
  const badgeTwoEl = productBadges.querySelector(".variant-badge-two");

  if (badgeOneEl) badgeOneEl.remove();
  if (badgeTwoEl) badgeTwoEl.remove();

  if (dateNow != "") dateNow = new Date(`${dateNow}`);
  if (startDateOne != "") startDateOne = new Date(`${startDateOne}`);
  if (endDateOne != "") endDateOne = new Date(`${endDateOne}`);
  if (startDateTwo != "") startDateTwo = new Date(`${startDateTwo}`);
  if (endDateTwo != "") endDateTwo = new Date(`${endDateTwo}`);

  if (badgeOne != "" && dateNow >= startDateOne && dateNow < endDateOne) {
    const el = createBadge(badgeOne, bgOne, colorOne, "variant-badge-one");
    productBadges.appendChild(el);
  }

  if (badgeTwo != "" && dateNow >= startDateTwo && dateNow < endDateTwo) {
    const el = createBadge(badgeTwo, bgTwo, colorTwo, "variant-badge-two");
    productBadges.appendChild(el);
  }
}

function createBadge(badge, bgColor, textColor, className) {
  const el = document.createElement("div");

  el.classList.add("product-badge", `${className}`);
  el.style.backgroundColor = `${bgColor}`;
  el.style.color = `${textColor}`;
  el.style.padding = ".4em";
  el.style.border = `1px solid ${bgColor}`;
  el.textContent = `${badge}`;

  return el;
}

window.swatchHandler = swatchHandler;
window.addProductBadges = addProductBadges;
window.createBadge = createBadge;

// Enable first swatch (For hide variant per location feature)

document.addEventListener('DOMContentLoaded', () => {
  function selectSwatch() {
    // 1. Initial Checks
    if (
      typeof templateName === 'undefined' || 
      templateName !== "product" || 
      new URLSearchParams(window.location.search).has('variant')
    ) return;

    const swatches = document.querySelectorAll('.product__color-swatches .product__color-swatch__el:not(.swatch__hide_variant)');
    if (!swatches.length) return;

    const target = Array.from(swatches).find(el => !el.classList.contains('disabled')) || swatches[0];
    
    function tryClick() {      
      if (target) {
        target.click(); 
      }
    }

    if (document.readyState === 'complete') {
      setTimeout(tryClick, 100); 
    } else {
      window.addEventListener('load', tryClick);
    }
  }

  selectSwatch();
});